import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { generateRandomGradient } from "../utils/gradientGenerator";
import { LockKeyhole, Clock, Logs, Play } from "lucide-react";
function SelectionCard({
  titile,
  no,
  time,
  athikaram,
  handleClick,
  gradient,
  isGameDisabled,
  level,
  datafile,
  gameid,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const safeGradient = gradient || generateRandomGradient();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ rotate: 360, scale: 1 }}
        transition={{
          type: "spring",
          stiffness: 260,
          damping: 20,
        }}
      >
        <div className="flex flex-col border border-gray-700 rounded-t-2xl relative">
          {isGameDisabled && (
            <div className="absolute inset-0 bg-black/50 rounded-t-lg z-50 flex items-center justify-center">
              <LockKeyhole size={64} color="#ffffff" strokeWidth={2} />
            </div>
          )}
          <div
            className={`rounded-t-2xl p-2 text-center text-white relative ${safeGradient}`}
          >
            <div className="flex items-center justify-between">
              <h3 className="text-2xl font-bold">{titile}</h3>
              <div ref={dropdownRef}>
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className="p-1.5 hover:bg-white/20 rounded-full transition-colors"
                >
                  <svg
                    className={`w-6 h-6 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                {isOpen && (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    className="absolute right-0 mt-1 w-64 bg-white rounded-lg shadow-lg z-40"
                  >
                    <div className="py-2 text-gray-800">
                      {athikaram.map((item, index) => (
                        <div
                          key={index}
                          className="px-2 py-2 hover:bg-gray-100 font-bold text-left text-sm"
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  </motion.div>
                )}
              </div>
            </div>
          </div>
          <div className="p-4 xl:py-9 xl:px-12 bg-indigo-50">
            <div className="grid grid-cols-2 gap-4 mb-1">
              <div className="bg-gray-100 rounded-md">
                <div className="flex flex-col items-center gap-1">
                  <Clock
                    className="w-6 h-6 text-indigo-600"
                    strokeWidth={2.5}
                  />
                  <h3 className="font-manrope text-xl font-bold">நேரம்</h3>
                </div>
                <div className="flex items-center justify-center mb-2">
                  <span className="mr-2 text-2xl font-semibold text-indigo-600">
                    {time}
                  </span>
                  <span className="text-lg text-gray-500">நிமிடம்</span>
                </div>
              </div>
              <div className="bg-gray-100 rounded-md ">
                <div className="flex flex-col items-center gap-1">
                  <Logs className="w-6 h-6 text-indigo-600" strokeWidth={2.5} />
                  <h3 className="font-manrope text-xl font-bold">குறள்கள்</h3>
                </div>
                <div className="flex items-center justify-center mb-2">
                  <span className="mr-2 text-2xl font-semibold text-indigo-600">
                    {no}
                  </span>
                  <span className="text-lg text-gray-500">மட்டும்</span>
                </div>
              </div>
            </div>

            <>
              <div className="flex justify-center items-center mb-2">
                <div className="text-blue-100 bg-gradient-to-bl from-[#0f172a] via-[#1e1a78] to-[#0f172a] border border-yellow-300 px-4 py-1 text-md font-bold rounded-xl inline-flex items-center">
                  நிலை
                  <span className="inline-flex items-center justify-center w-6 h-6 ms-2 text-md font-semibold text-blue-100 bg-red-500 rounded-full">
                    {level}
                  </span>
                </div>
              </div>
            </>
            <button
              disabled={isGameDisabled}
              type="button"
              onClick={() =>
                handleClick(
                  no,
                  athikaram,
                  time,
                  titile,
                  level,
                  datafile,
                  gameid
                )
              }
              className={`py-3 px-6 
                ${
                  !isGameDisabled
                    ? "bg-indigo-600 hover:bg-indigo-700 hover:-translate-y-0.5 active:translate-y-0.5"
                    : "bg-indigo-200"
                } 
                transform transition-all duration-200
                text-white font-bold text-lg
                rounded-xl
                shadow-[0_5px_0_rgb(67,56,202)]
                active:shadow-[0_2px_0_rgb(67,56,202)]
                text-center w-fit block mx-auto 
                ${!isGameDisabled ? "cursor-pointer" : "cursor-not-allowed"}
                flex items-center gap-2`}
            >
              <Play className="w-8 h-8 sm:hidden" />
              <span className="hidden sm:inline">ஆட்டத்தை தொடங்கவும்</span>
            </button>
          </div>
        </div>
      </motion.div>
    </>
  );
}

export default SelectionCard;
